module.exports = __webpack_public_path__ + "img/pasien_berhenti.decbe5e1.png";